/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import styles from './styles.module.css';
import { FaTimes, FaInstagram, FaTiktok } from 'react-icons/fa';

const SocialMedia = () => {
  return (
    <div className={styles.mediaBody}>
      <div className={styles.media}>
        <div className={styles.mediaCon}>
          <p>Follow us on social media</p>
          <div className={styles.iconContainer}>
            <a href="https://www.x.com/lormami_" className={styles.iconLink}>
              <FaTimes className={styles.icon} />
            </a>
            <a href="https://www.instagram.com/wear_lormami" target="_blank" rel="noopener noreferrer" className={styles.iconLink}>
              <FaInstagram className={styles.icon} />
            </a>
            <a href="https://www.tiktok.com/@lormami_" target="_blank" rel="noopener noreferrer" className={styles.iconLink}>
              <FaTiktok className={styles.icon} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialMedia;